import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Grid,
    Stack,
    Typography,
} from "@mui/material";

import {
    Replay,
    Cancel,
    LockOpen,
} from "@mui/icons-material";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import { paymentsApi } from "../API/paymentsApi";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import Breadcrumb from "../NewUI/NewComponents/Breadcrumb";
import Swal from "sweetalert2";

export default function PaymentDetails() {

    const { id } = useParams();

    const [payment, setPayment] = useState(null);

    const loadPayment = async () => {

        const response =
            await paymentsApi.getById(id);

        setPayment(response.data);
    };

    useEffect(() => {
        loadPayment();
    }, [id]);

    if (!payment) {
        return <Typography>Loading...</Typography>;
    }

    const status = payment.paymentStatus || payment.status;
    const reference = payment.referenceNumber || payment.reference;
    const gateway = payment.gatewayName || payment.gatewayCode || payment.gateway;

    const capture = async () => {

        if (!payment.gatewayPaymentId) {
            Swal.fire("No gateway payment id on this record", "", "warning");
            return;
        }

        await paymentsApi.capture({
            gatewayPaymentId: payment.gatewayPaymentId,
            amount: payment.amount,
        });

        loadPayment();
    };

    const refund = async () => {

        if (!reference) {
            Swal.fire("No reference number on this record", "", "warning");
            return;
        }

        if (!window.confirm(`Refund ${payment.amount}?`)) {
            return;
        }

        await paymentsApi.refund({
            referenceNumber: reference,
            refundAmount: payment.amount,
        });

        loadPayment();
    };

    const cancel = async () => {

        if (!reference) {
            Swal.fire("No reference number on this record", "", "warning");
            return;
        }

        if (!window.confirm("Cancel this payment?")) {
            return;
        }

        await paymentsApi.cancel({
            referenceNumber: reference,
        });

        loadPayment();
    };

    return (

        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <div className="UI-container">
                    <div className="UI-card">
                        <div className="UI-header">
                            <Breadcrumb breadcrumbs={[{ name: "Home", path: "/superadminmasters" }, { name: "Payments Dashboard", path: null }]} />
                            <div className="UI-header-content">

                                <div>
                                    <h1 className="UI-title">
                                        Payments
                                    </h1>
                                    <p className="UI-subtitle">
                                        List of all payments
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="UI-form-container">


                            <Typography variant="h4" mb={3}>
                                Payment Details
                            </Typography>

                            <Card>

                                <CardContent>

                                    <Grid container spacing={3}>

                                        <Grid item xs={12} md={6}>
                                            <Typography color="text.secondary">
                                                Payment ID
                                            </Typography>

                                            <Typography>
                                                {payment.paymentId || payment.id}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography color="text.secondary">
                                                Reference
                                            </Typography>

                                            <Typography>
                                                {reference}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography color="text.secondary">
                                                Order ID
                                            </Typography>

                                            <Typography>
                                                {payment.orderId}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography color="text.secondary">
                                                Gateway
                                            </Typography>

                                            <Typography>
                                                {gateway}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography color="text.secondary">
                                                Amount
                                            </Typography>

                                            <Typography variant="h5">
                                                ₹{payment.amount}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography color="text.secondary">
                                                Status
                                            </Typography>

                                            <Chip
                                                label={status}
                                                color={
                                                    status === "SUCCESS"
                                                        ? "success"
                                                        : "warning"
                                                }
                                            />
                                        </Grid>

                                    </Grid>

                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        mt={4}
                                    >

                                        {status === "AUTHORIZED" && (
                                            <Button
                                                variant="contained"
                                                startIcon={<LockOpen />}
                                                onClick={capture}
                                            >
                                                Capture
                                            </Button>
                                        )}

                                        {status === "SUCCESS" && (
                                            <Button
                                                variant="outlined"
                                                color="warning"
                                                startIcon={<Replay />}
                                                onClick={refund}
                                            >
                                                Refund
                                            </Button>
                                        )}

                                        {status !== "CANCELLED" &&
                                            status !== "REFUNDED" && (
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    startIcon={<Cancel />}
                                                    onClick={cancel}
                                                >
                                                    Cancel
                                                </Button>
                                            )}

                                    </Stack>

                                </CardContent>

                            </Card>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
